import script from "./Empty.vue?vue&type=script&setup=true&lang=js"
export * from "./Empty.vue?vue&type=script&setup=true&lang=js"

import "./Empty.vue?vue&type=style&index=0&id=9e56600c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e56600c"]])

export default __exports__